import { schemes, zSchema } from "@zeal/common";

const zContributionType = zSchema.enum(["cents", "percentage", "dollars"]);

export const postContractorPaymentDeductionRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  contractorPaymentID: schemes.mongoObjectId(),
  deductionTemplateID: schemes.mongoOrUuid(),
  deduction: zSchema
    .object({
      contractor_contribution: zSchema
        .object({
          value: schemes
            .numberish()
            .pipe(zSchema.number().nonnegative())
            .nullable(),
          contribution_type: zContributionType.optional(),
        })
        .optional(),
      additional_fields: zSchema
        .object({
          agency: zSchema
            .object({
              name: zSchema.string().optional(),
              address: zSchema.string().optional(),
            })
            .or(zSchema.string())
            .optional(),
          case_id: zSchema.string().optional(),
          order_number: zSchema.string().optional(),
        })
        .optional(),
    })
    .strict()
    .optional()
    .default({}),
});

export type TPostContractorPaymentDeductionRequest = zSchema.infer<
  typeof postContractorPaymentDeductionRequestSchema
>;
